import { mapData } from "@/stuff/DataMapping";

export interface ICompaniesHouseResponse {
    found: boolean;
    legalName: string;
    companyRegNo: string;
}

export class CompaniesHouseResponse implements ICompaniesHouseResponse {

    constructor (data?: ICompaniesHouseResponse) {
        if (data) this.update(data);
    }

    update(data: ICompaniesHouseResponse): void {
        mapData(data, {
            root: () => this
        });
    }

    found: boolean = false;
    legalName: string = "";
    companyRegNo: string = "";

}